import React, { useEffect, useState } from 'react'
import StudentCard from '../students/StudentCard'
import ApplicantTableSnippet from '../applications/ApplicantTableSnippet'
import { studentsDefaultDisplay, debounce, tableHeadersFields } from '../../../utils'
import StudentStatus from '../../elements/StudentStatus'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchStudents } from '../../../store/actions/studentsActions';
import { transactionTimeStamp } from '../../../utils';
import StudentsFilters from '../../elements/filters/StudentsFilters';
import ArrowUpTrayIcon from '../../elements/icons/ArrowUpTrayIcon';
import SquaresIcon from '../../elements/icons/SquaresIcon';
import ViewListIcon from '../../elements/icons/ViewListIcon';
import SearchField from '../../elements/SearchField';
import Loader from '../../elements/Loader';
import Pagination from '../../elements/Pagination';
import DataTable from '../../elements/DataTable';
import EmptyState from '../../elements/EmptyState';
const ParentStudents = ({parent}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const studentsSelector = useSelector((state => state.students))
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [reload, setReload] = useState(0);
    const [activeFilters, setActiveFilters] = useState(parent?._id ? `parent=${parent._id}` : '');

    useEffect(() => {
        dispatch(fetchStudents(activeFilters, page, perPage))
        return () => {
        
        };
    }, [page, perPage, dispatch, reload, activeFilters]);

    const tableOptions = {
        selectable: true,
        multiselect: true,
        clickableRows: true,
        rowAction: (rowIndex)=>{
        navigate(`/admin/students/student/${studentsSelector.students.students[rowIndex]._id}`)
        }
    }

    const columnWidths = {
        student: 'w-3/12',
        admissionNumber: 'w-2/12',
        class: 'w-1/12',
        // parent: 'w-2/12',
        // admission: 'w-2/12',
        status: 'w-2/12',
        dateAdmitted: 'w-3/12',
    }

    const columnDataStyles = {}
    
    const cleanUpTableData = (array) => {
        if(!array) return
        let finalResult = [] 
        array.forEach((object, objectIndex) => {
            const applicationObject = {
                student: <ApplicantTableSnippet applicant={object} />,
                admissionNumber: object.admissionNumber,
                class: object?.class?.class?.name,
                status: <StudentStatus status={object.status} />,
                dateAdmitted: transactionTimeStamp(object.createdAt).date,
            }

            finalResult.push(applicationObject)
        })
        return finalResult
    }

    const [view, setView] = useState(studentsDefaultDisplay() || 'list');
    const changeStudentsView = (view) => {
        localStorage.setItem("studentsDefaultDisplay", view);
        setView(view)
    }

    const searchStudents = debounce((term) => {
        if(!term || term === '') {
            setReload(reload + 1)
            return
        }
        dispatch(fetchStudents(`parent=${parent?._id}&searchTerm=${term}`, 0, 0))
    })
    return (
        <div className='w-full'>
            <div className='w-full p-8'>
                <div className="w-full mx-auto">
                    <h4 className='font-medium text-lg mb-3 text-gray-400'>Students linked to this parent</h4>
                    <div className='w-2/3'>
                        <p className='text-gray-500 my-3 text-sm'>
                            Below is a list of students at Vaatia College linked to this parent <span className="font-semibold text-black">{parent.fullName}</span>. You can click on a student to view their profile and other details.
                        </p>
                    </div>
                </div>

                <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
                    <div className='w-1/2'>
                        {/* <Filters /> */}
                        <StudentsFilters applyFilters={(filters)=>{
                            console.log('filters => ', filters)
                            setActiveFilters(filters)
                        }} />
                    </div>
                    <div className='w-1/2 flex flex-row-reverse gap-x-2'>
                        <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border w-[300px]`}>
                            <ArrowUpTrayIcon className={`w-5 h-5`} />
                            Export Students
                        </button>
                        
                        <button onClick={()=>{changeStudentsView('grid')}} className={`${view === 'grid' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                            <SquaresIcon className={`w-7 h-7`} />
                        </button>

                        <button onClick={()=>{changeStudentsView('list')}} className={`${view === 'list' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                            <ViewListIcon className={`w-7 h-7`} />
                        </button>

                        <div className='w-[370px]'>
                            <SearchField 
                                placeholderText={`Search by student name or admission number`}
                                showResultsDropDown={false}
                                triggerSearch={(term)=>{searchStudents(term)}}
                                performingSearch={studentsSelector.loadingStudents}
                            />
                        </div>
                    </div>
                </div>

                {studentsSelector.loadingStudents ? 
                    <Loader />
                :
                <>
                    {studentsSelector.students?.students?.length > 0 ? 
                    <div className=''>
                        {view === 'grid' && 
                        <>
                            <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8'>
                                {studentsSelector?.students?.students?.map((student, studentIndex)=>(
                                    <div key={studentIndex}>
                                        <StudentCard student={student} />
                                    </div>
                                ))}
                            </div>
                            <Pagination 
                                pagination={{
                                    perPage, 
                                    page,
                                    totalItems: studentsSelector.students.total,
                                }} 
                                changePage={setPage} 
                                updatePerPage={setPerPage}
                            />
                        </>
                        }
                        {view === 'list' && <div className='w-full'>
                            <DataTable
                                tableHeaders={tableHeadersFields(cleanUpTableData(studentsSelector.students.students)[0]).headers} 
                                tableData={cleanUpTableData(studentsSelector.students?.students)} 
                                columnWidths={columnWidths}
                                columnDataStyles={columnDataStyles}
                                allFields={tableHeadersFields(cleanUpTableData(studentsSelector.students?.students)[0]).fields}
                                onSelectItems={()=>{}}
                                tableOptions={tableOptions}
                                pagination={{
                                    perPage, 
                                    page,
                                    totalItems: studentsSelector.students.total,
                                }}
                                onSelectSingle={()=>{}}
                                changePage={setPage}
                                updatePerPage={setPerPage}
                            />
                        </div>
                        }
                    </div>
                    : 
                    <div className='mt-24 w-1/2 mx-auto'>
                        <EmptyState emptyStateText={`There are no students on this platform yet!`} />
                    </div>

                    }
                </>
                }
            </div>
        </div>
    )
}

export default ParentStudents
